export { default as addIcon } from './aggiungi-tabella.svg'
export { default as addIcon_over } from './aggiungi-over.svg'
export { default as addIcon_popUp } from './aggiungi-pop-up.svg'
export { default as addIcon_top } from './top-aggiungi.svg'
export { default as addIcon_topOver } from './top-aggiungi-over.svg'
export { default as alertIcon } from './alert.svg'
export { default as alertIcon_tri } from './avviso.svg'
export { default as cardIcon } from './icona-card-30.svg'
export { default as closeIcon } from './chiudi-tabella.svg'
export { default as closeIcon_over } from './chiudi-over.svg'
export { default as closeIcon_popUp } from './chiudi-pop-up.svg'
export { default as deleteIcon } from './delete-tabella.svg'
export { default as deleteIcon_over } from './delete-over.svg'
export { default as deleteIcon_popUp } from './delete-pop-up.svg'
export { default as downloadIcon } from './download-tabella.svg'
export { default as downloadIcon_over } from './download-over.svg'
export { default as downloadIcon_popUp } from './download-pop-up.svg'
export { default as editIcon } from './edit-tabella.svg'
export { default as editIcon_over } from './edit-over.svg'
export { default as editIcon_popUp } from './edit-pop-up.svg'
export { default as focusIcon } from './focus-tabella.svg'
export { default as focusIcon_over } from './focus-over.svg'
export { default as focusIcon_popUp } from './focus-pop-up.svg'
export { default as forwardIcon } from './menu-forward.svg'
export { default as forwardIcon_over } from './menu-forward-over.svg'
export { default as infoIcon } from './info.png'
export { default as infoIcon_over } from './info-over.png'
export { default as keyIcon } from './key.svg'
export { default as keyIcon_over } from './key-over.svg'
export { default as pinIcon } from './pin.svg'
export { default as profileIcon30 } from './icona-profilo-30.svg'
export { default as profileIcon50 } from './icona-profilo-50.svg'
export { default as saveIcon } from './salva-tabella.svg'
export { default as saveIcon_over } from './salva-over.svg'
export { default as saveIcon_popUp } from './salva-pop-up.svg'
export { default as settingsIcon } from './menu-impostazioni.svg'
export { default as settingsIcon_over } from './menu-impostazioni-over.svg'

export const topBarIcons = {
    logOut: require('./top_bar-log-out.svg').default,
    logOut_over: require('./top_bar-log-out-over.svg').default,
	manual: require('./top_bar-manual.png'),
    manual_over: require('./top_bar-manual-over.png'),
    profile: require('./top_bar-profilo.svg').default,
    profile_over: require('./top_bar-profilo-over.svg').default,
    venue: require('./top_bar-venue-generic.svg').default,
    venue_over: require('./top_bar-venue-generic-over.svg').default,
}

export const menuIcons = {
    admin: require('./menu-amministrazione.svg').default,
	admin_over: require('./menu-amministrazione-over.svg').default,
	alert: require('./menu-zone-alert.svg').default,
	alert_over: require('./menu-zone-alert-over.svg').default,
	analysis: require('./menu-analisi-dati.png'),
	analysis_over: require('./menu-analisi-dati-over.png'),
	back: require('./menu-back.svg').default,
	back_over: require('./menu-back-over.svg').default,
	chart: require('./menu-zone-trend.svg').default,
	chart_over: require('./menu-zone-trend-over.svg').default,
	chart2: require('./menu-grafici.png'),
	chart2_over: require('./menu-grafici-over.png'),
	contact: require('./menu-assistenza.png'),
	contact_over: require('./menu-assistenza-over.png'),
	data: require('./menu-zone-dati.svg').default,
	data_over: require('./menu-zone-dati-over.svg').default,
	device: require('./menu-dispositivi.svg').default,
	device_over: require('./menu-dispositivi-over.svg').default,
	dss: require('./menu-dss.png'),
	dss_over: require('./menu-dss-over.png'),
	freezing: require('./menu-gelata.png'),
	freezing_over: require('./menu-gelata-over.png'),
	home: require('./menu-home.svg').default,
	home_over: require('./menu-home-over.svg').default,
	irrigation: require('./menu-irrigazione.png'),
	irrigation_over: require('./menu-irrigazione-over.png'),
	maintenance: require('./manutenzione.png'),
	maintenance_over: require('./manutenzione-over.png'),
	phyto: require('./menu-fitofarmaci.png'),
	phyto_over: require('./menu-fitofarmaci-over.png'),
	service: require('./menu-agriservice.svg').default,
	service_over: require('./menu-agriservice-over.svg').default,
	settings: require('./menu-impostazioni.svg').default,
	settings_over: require('./menu-impostazioni-over.svg').default,
    settings2: require('./menu-impostazioni.png'),
	settings2_over: require('./menu-impostazioni-over.png'),
	user: require('./menu-user-management.svg').default,
	user_over: require('./menu-user-management-over.svg').default,
}

export const projectTypeIcons = {
    agrismart: require('./agrismart-icon.svg').default,
    agrismart_over: require('./agrismart-icon-over.svg').default,
    agrismart_small: require('./agrismart-icon-small.svg').default,
    agrismart_smallOver: require('./agrismart-icon-small-over.svg').default,
    badge: require('./home-badge-icon.svg').default,
    badge_over: require('./home-badge-icon-over.svg').default,
    badge_small: require('./project-badge-icon-small.svg').default,
    badge_smallOver: require('./project-badge-icon-over-small.svg').default,
    switch: require('./home-switch-icon.svg').default,
    switch_over: require('./home-switch-icon-over.svg').default,
    switch_small: require('./project-switch-icon-small.svg').default,
    switch_smallOver: require('./project-switch-icon-over-small.svg').default,
    tracker: require('./tracker-icon.svg').default,
    tracker_over: require('./tracker-icon-over.svg').default,
    tracker_small: require('./tracker-icon-small.svg').default,
    tracker_smallOver: require('./tracker-icon-small-over.svg').default,
	unknown: require('./alert.svg').default,
    unknown_over: require('./alert.svg').default,
    unknown_small: require('./alert.svg').default,
    unknown_smallOver: require('./alert.svg').default,
}

export const cropIcons = {
	agrumi: require('./crop-agrumi.png'),
	agrumi_over: require('./crop-agrumi-over.png'),
	grano: require('./crop-grano.png'),
	grano_over: require('./crop-grano-over.png'),
    melo: require('./crop-melo.svg').default,
    melo_over: require('./crop-melo-over.svg').default,
    olivo: require('./crop-olivo.svg').default,
    olivo_over: require('./crop-olivo-over.svg').default,
    vite: require('./crop-vite.svg').default,
    vite_over: require('./crop-vite-over.svg').default,
}

export const pinIcons = {
	alert: require('./pin-alert.svg').default,
	azure: require('./pin-azure.svg').default,
	black: require('./pin-black.svg').default,
	close: require('./pin-close.svg').default,
	green: require('./pin-green.svg').default,
	grey: require('./pin-grey.svg').default,
	move: require('./pin-move.svg').default,
	off: require('./pin-off.svg').default,
	on: require('./pin-on.svg').default,
	open: require('./pin-open.svg').default,
	red: require('./pin.svg').default,
	sensor: require('./pin-sensor.svg').default,
	start: require('./pin-start.svg').default,
	stillAlive: require('./pin-still-alive.svg').default,
	stop: require('./pin-stop.svg').default,
	violet: require('./pin-violet.svg').default,
	yellow: require('./pin-yellow.svg').default,
}